<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6m1.8 18H14l-2-3.4-2 3.4H8.2l2.9-4.5L8.2 11H10l2 3.4 2-3.4h1.8l-2.9 4.5 2.9 4.5M13 9V3.5L18.5 9H13z"/>
    </svg>
</template>

<script>
export default {
    name: 'FileExcelIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
